import { useMemo } from "react";

import { Route, Routes, useLocation } from "react-router";

import { Menu, MenuItemLink } from "simplydo/react/ui/menu";

import { useAppSelector } from "store";
import util from "utils/utils";

import CalendarSettings from "components/calendars/CalendarManagement/EditCalendar/CalendarSettings";

import type { ChallengeDetail } from "../../types";
import Planner from "./Planner";

type PlannerMenuProps = { challenge: ChallengeDetail };

const PlannerMenu = ({ challenge }: PlannerMenuProps) => {
  const challengeId = challenge._id;
  const calendarId = challenge.calendar?._id;
  const user = useAppSelector((state) => state.user);
  const location = useLocation();

  const canManageChallenge = useMemo(
    () => util.canManageChallenge(user, challenge),
    [user, challenge],
  );
  const canEditPlanner = useMemo(
    () =>
      canManageChallenge ||
      (!!calendarId &&
        !!challengeId &&
        util.hasPermission(user, "calendar.edit", calendarId, challengeId)),
    [user, canManageChallenge, calendarId, challengeId],
  );

  return (
    <div>
      <Menu variant="underline">
        <MenuItemLink
          to=".."
          active={util.activePath(/\/planner(\/events\/[^/]+)?$/, location)}
        >
          Planner
        </MenuItemLink>
        {canEditPlanner ? (
          <MenuItemLink
            to="../settings"
            active={util.activePath("/planner/settings", location)}
          >
            Settings
          </MenuItemLink>
        ) : null}
      </Menu>

      <Routes>
        {canEditPlanner && challengeId && calendarId ? (
          <Route
            path="settings"
            element={
              <CalendarSettings
                forType="challenge"
                forId={challengeId}
                calendarId={calendarId}
              />
            }
          />
        ) : null}
        <Route path="/" element={<Planner challenge={challenge} />} />
        <Route
          path="events/:eventId"
          element={<Planner challenge={challenge} />}
        />
      </Routes>
    </div>
  );
};

export default PlannerMenu;
